import * as utils from '@tencent/ovb-utils';
var comTool = {
    /** 检查是否支持es6语法 */
    supportES6: function () {
        try {
            // eslint-disable-next-line no-eval
            eval('var foo = (x)=>x+1');
        }
        catch (e) {
            return false;
        }
        return true;
    },
    isObject: function (list) {
        if (typeof list === 'object' && list.constructor === Object) {
            return true;
        }
        return false;
    },
    createGUID: function (lenParam) {
        if (lenParam === void 0) { lenParam = 32; }
        var len = lenParam || 32;
        var guid = '';
        for (var i = 1; i <= len; i++) {
            var n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
        }
        return guid;
    },
    xss: utils.xssFilter,
    /** 计算剔除discontinuity后的播放时间 */
    removeDiscontinuityTimeRangesFromPlayTime: function (time, discontinuities) {
        var inAdRange = comTool.findDiscontinuityTimeRangeAtPlaytime(time, discontinuities);
        if (inAdRange)
            return inAdRange.start;
        var res = time;
        discontinuities.forEach(function (range) {
            if (range.end < time) {
                res -= (range.end - range.start);
            }
        });
        return res;
    },
    /** 找到当前播放时间所在的discontinuity区间 */
    findDiscontinuityTimeRangeAtPlaytime: function (time, discontinuities) {
        return comTool.mergeTimeRanges(discontinuities).find(function (range) { return time >= range.start && time <= range.end; });
    },
    /** 合并多个连续的discontinuity区间 */
    mergeTimeRanges: function (ranges) {
        var curStart = -1;
        var lastEnd = -1;
        var mergedRanges = [];
        ranges.forEach(function (range) {
            var start = range.start, end = range.end;
            if (start <= lastEnd) {
                lastEnd = end;
                return;
            }
            lastEnd >= 0 && mergedRanges.push({
                start: curStart,
                end: lastEnd,
            });
            curStart = start;
            lastEnd = end;
        });
        if (curStart >= 0 && lastEnd >= 0)
            mergedRanges.push({ start: curStart, end: lastEnd });
        return mergedRanges;
    },
    /**
     * 对比版本号
     * @param  {String} nParam
     * @param  {String} kParam
     * @return {Number}   1:n>k, 0:n=k, -1:n<k
     */
    compareVersion: utils.compareVersions,
    formatPlayTime: function (timeParam) {
        var time = timeParam;
        if (typeof time === 'string')
            time = parseInt(time, 10);
        if (typeof time !== 'number' || Number.isNaN(time))
            return '00:00';
        var formatZero = function (num) {
            if (num < 10)
                return "0".concat(num);
            return num;
        };
        var h = Math.floor(time / 3600);
        var m = Math.floor((time - (h * 3600)) / 60);
        var s = Math.floor(time - (h * 3600) - (m * 60));
        if (h === 0) {
            return [formatZero(m), formatZero(s)].join(':');
        }
        return [h, formatZero(m), formatZero(s)].join(':');
    },
    dateFormat: function (fmtParam, timeParam) {
        if (timeParam === void 0) { timeParam = Date.now(); }
        return utils.dateFormat(timeParam, fmtParam || 'yyyy-MM-dd hh:mm:ss');
    },
    base64ToArrayBuffer: function (base64) {
        var binaryString = window.atob(base64);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    },
    /**
     * 当前页面是否隐藏，如果不支持hidden属性，则返回-1
     * @return {0 | 1 | -1} 1:隐藏，0:显示，-1:不支持hidden属性
     */
    isPageHidden: function () {
        var hiddenTags = ['hidden', 'msHidden', 'webkitHidden'];
        var tag = hiddenTags.find(function (i) { return typeof document[i] !== 'undefined'; });
        if (tag) {
            return document[tag] ? 1 : 0;
        }
        return -1;
    },
    /**
     * 使用requestAnimationFrame实现倒计时功能（未实现取消倒计时，慎用）
     * @param callback 倒计时后的回调
     * @param time 倒计时长，单位毫秒
     */
    setTimeoutByRAF: function (callback, time) {
        var RAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
        var startTime = +new Date();
        function loop() {
            if (+new Date() - startTime > time) {
                callback();
            }
            else {
                RAF(loop);
            }
        }
        loop();
    },
    /**
     * 将某个实例上指定的方法扩展到目标prototype上
     */
    assignApiToPrototype: function (fromInst, toPrototype, apis) {
        var instPrototype = Object.getPrototypeOf(fromInst);
        var existMembers = Object.getOwnPropertyNames(toPrototype);
        for (var i = 0, len = apis.length; i < len; i++) {
            var apiName = apis[i];
            var hasExisted = existMembers.indexOf(apiName) !== -1;
            if (hasExisted || typeof instPrototype[apiName] !== 'function') {
                continue;
            }
            toPrototype[apiName] = instPrototype[apiName].bind(fromInst);
        }
    },
};
export default comTool;
